import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Authorization } from "../../Context/Authorization";
import Preloader from "../../shared/PreLoaders";
import { toast } from "react-toastify";

const labelStyle = {
  fontSize: 12,
  fontWeight: 600,
  color: "#2D3748",
  marginBottom: 6,
  display: "block",
};
const valueBoxStyle = {
  padding: "8px 0",
  fontSize: 14,
  fontWeight: 600,
  color: "#1A202C",
  minHeight: "auto",
  background: "transparent",
  border: "none",
  borderBottom: "1px dashed #E2E8F0",
  borderRadius: 0,
  display: "block",
  wordBreak: "break-word",
};

const Field = ({ label, value }) => (
  <div style={{ marginBottom: 20 }}>
    <label style={labelStyle}>{label}</label>

    <div style={valueBoxStyle}>
      {value || "—"}
    </div>
  </div>
);
const Section = ({ icon, title, children, cols = 2 }) => (
  <div style={{ marginBottom: 24 }}>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginBottom: 14,
        paddingBottom: 10,
        borderBottom: "1px solid #EDF2F7",
      }}
    >
      <span
        style={{
          width: 28,
          height: 28,
          background: "linear-gradient(135deg,#1B5E20,#43A047)",
          borderRadius: 7,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontSize: 13,
          flexShrink: 0,
        }}
      >
        <i className={`mdi ${icon}`} />
      </span>

      <span
        style={{
          fontSize: 13,
          fontWeight: 700,
          color: "#2D3748",
        }}
      >
        {title}
      </span>
    </div>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${cols}, minmax(0,1fr))`,
        gap: "0 20px",
      }}
    >
      {children}
    </div>
  </div>
);

const formatDate = (date) =>
  date ? new Date(date).toLocaleDateString("en-IN") : "—";

const VFC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const Api = process.env.REACT_APP_API;
  const location = useLocation();

  const vfc = location.state?.vfc;
  const [loading, setLoading] = useState(false);
  //const [vfc, setVfc] = useState(null);


  if (!vfc) {
    return (
      <div style={{ padding: 20 }}>
        No JFMC data found
      </div>
    );
  }

  return (
    <div>
      <Preloader loading={loading} />

      {/* Header */}
      <div
        style={{
          marginBottom: 20,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div>
          <h4
            style={{
              margin: 0,
              fontWeight: 700,
              color: "#1A202C",
              fontSize: 18,
            }}
          >
            View JFMC Details
          </h4>

          <div
            style={{
              fontSize: 12,
              color: "#718096",
              marginTop: 3,
            }}
          >
            <span style={{ color: "#A0AEC0" }}>JFMC</span>
            <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
            <span
              style={{
                color: "#2E7D32",
                fontWeight: 600,
              }}
            >
              View Details
            </span>
          </div>
        </div>

        <button
          onClick={() => navigate(-1)}
          style={{
            padding: "10px 18px",
            border: "none",
            borderRadius: 8,
            background: "#2E7D32",
            color: "#fff",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          Back
        </button>
      </div>

      {/* Main Card */}
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          border: "1px solid #E2E8F0",
          boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
          overflow: "hidden",
        }}
      >
        {/* Card Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            padding: "14px 20px",
            borderBottom: "1px solid #EDF2F7",
            background:
              "linear-gradient(135deg,#1B5E20,#2E7D32)",
          }}
        >
          <span
            style={{
              width: 36,
              height: 36,
              background: "rgba(255,255,255,0.15)",
              borderRadius: 9,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: 18,
            }}
          >
            <i className="mdi mdi-home-city-outline" />
          </span>

          <div>
            <div
              style={{
                fontSize: 14,
                fontWeight: 700,
                color: "#fff",
              }}
            >
              {vfc.vfcName}
            </div>

            <div
              style={{
                fontSize: 11,
                color: "rgba(255,255,255,0.7)",
              }}
            >
              Complete JFMC Information
            </div>
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: "24px" }}>
          {/* Basic */}
          <Section
            icon="mdi-home-group"
            title="Basic Information"
          >
            <Field label="JFMC Name" value={vfc.vfcName} />

            <Field
              label="Circle"
              value={vfc.rangeId.divisionId.circleId.circleName}
            />
            <Field
              label="Division"
              value={vfc.rangeId.divisionId.divisionName}
            />
            <Field
              label="Range"
              value={vfc.rangeId?.rangeName}
            />
            <Field
              label="Beat Name"
              value={vfc.beatName}
            />
            <Field
              label="Beat Code"
              value={vfc.beatCode}
            />
          </Section>

          {/* Location */}
          <Section
            icon="mdi-map-marker-outline"
            title="Location Details"
          >
            <Field
              label="District"
              value={vfc.district}
            />
            <Field
              label="LGD Code"
              value={vfc.lgdCode}
            />
            <Field
              label="BDO Office Name"
              value={vfc.bdoOfficeName}
            />
            <Field
              label="BDO Office Code"
              value={vfc.bdoOfficeCode}
            />
            <Field
              label="Village Name"
              value={vfc.villageName}
            />
            <Field
              label="Village Code"
              value={vfc.villageCode}
            />
            <Field
              label="Location"
              value={vfc.location}
            />
            <Field
              label="Address"
              value={vfc.address}
            />
            <Field
              label="Panchayath"
              value={vfc.panchayath}
            />
            <Field
              label="Pin Code"
              value={vfc.pinCode}
            />
            <Field
              label="Thaluk"
              value={vfc.thaluk}
            />
            <Field
              label="Thaluk Code"
              value={vfc.thalukCode}
            />
          </Section>

          {/* Registration */}
          <Section
            icon="mdi-file-certificate-outline"
            title="Registration Details"
          >
            <Field
              label="Date of Establishment"
              value={formatDate(
                vfc.dateOfEstablishment
              )}
            />
            <Field
              label="Registration Number"
              value={vfc.registrationNo}
            />
            <Field
              label="Registration Date"
              value={formatDate(
                vfc.registrationDate
              )}
            />
            <Field
              label="Total Family"
              value={vfc.totalFamily}
            />
            <Field
              label="Total Population"
              value={vfc.totalPopulation}
            />
            <Field
              label="VFC Family"
              value={vfc.vfcFamily}
            />
          </Section>

          {/* Bank */}
          <Section
            icon="mdi-bank-outline"
            title="Bank Details"
          >
            <Field
              label="Bank Name"
              value={vfc.bankName}
            />
            <Field
              label="Branch"
              value={vfc.branch}
            />
            <Field
              label="Account Number"
              value={vfc.accountNumber}
            />
            <Field
              label="IFSC Code"
              value={vfc.ifscCode}
            />
          </Section>
          <Section
            icon="mdi-map-marker-outline"
            title="Balance Details"
          >
            <Field
              label="Latest Bank Balance"
              value={
                vfc.latestBankBalance?.$numberDecimal
                  ? Number(vfc.latestBankBalance.$numberDecimal).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : vfc.latestBankBalance || "—"
              }
            />
            <Field
              label="Balance Date"
              value={
                vfc.latestBalanceDate
                  ? new Date(vfc.latestBalanceDate).toLocaleDateString("en-IN")
                  : "—"
              }
            />
          </Section>
        </div>
      </div>
    </div>
  );
};

export default VFC;